// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__Z_KD3","social":"footer_social__9XPQK","disclaimer":"footer_disclaimer__66GhW","legalText":"footer_legalText__A92gI"};